import React, { useState } from "react";

import { ModalError } from "@/components/molecules/ModalError";
import { FormCheckout } from "../FormCheckout";
import { WeGuarantee } from "../WeGuarantee";

export const FormContainer = ({ errorStep, nextStep, initialStep, terms }) => {
  const [modalErrorData, setModalErrorData] = useState({
    isOpen: false,
    icon: "RideFiErrorCardLight",
    title: "",
    message: "",
    buttonText: "",
    callBack: () => {},
    close: () => {},
  });

  return (
    <>
      <FormCheckout
        errorStep={errorStep}
        nextStep={nextStep}
        initialStep={initialStep}
        terms={terms}
        setModalErrorData={setModalErrorData}
      />
      <WeGuarantee />
      <ModalError
        open={modalErrorData.isOpen}
        icon={modalErrorData.icon}
        title={modalErrorData.title}
        message={modalErrorData.message}
        buttonText={modalErrorData.buttonText}
        onClose={() => {
          setModalErrorData({ ...modalErrorData, isOpen: false });
          if (modalErrorData.close) {
            modalErrorData.close && modalErrorData.close();
          }
        }}
        callBackAction={modalErrorData.callBack}
      />
    </>
  );
};
